import PublicLayout from "@/components/PublicLayout";

const TEAM = "https://images.unsplash.com/photo-1509099896299-af46ad97ff57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwcHJvZmVzc2lvbmFsc3xlbnwwfHx8fDE3ODAyMjgzMDB8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <PublicLayout>
      <section className="border-b border-[#E5E2DE] bg-white py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-12 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-7">
              <div className="mb-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#E87722]">About JRC</div>
              <h1 className="font-heading text-4xl font-bold text-ink sm:text-5xl lg:text-6xl">
                Financial dignity, <span className="text-[#5B2C82]">delivered.</span>
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft">
                Joseph Roberts Capital is a Zimbabwean microfinance company built on a simple
                idea: that access to fair, fast credit should not be a privilege. We design
                products around how Zimbabweans actually earn, spend, save and grow.
              </p>
            </div>
            <div className="lg:col-span-5">
              <img src={TEAM} alt="Team" className="aspect-[4/5] w-full rounded-2xl object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-10 md:grid-cols-3">
            {[
              { t: "Our mission", d: "To deliver innovative, client-centric microfinance solutions across urban and rural Zimbabwe — particularly for under-served, hard-working communities." },
              { t: "Our values", d: "Integrity, empathy, and decisive professionalism. We treat every applicant like a partner, not a number." },
              { t: "Our promise", d: "Transparent rates. No hidden fees. Clear answers — even when the answer is 'not today, but here's why and what we can do.'" },
            ].map((b) => (
              <div key={b.t} className="rounded-2xl border border-[#E5E2DE] bg-white p-6">
                <h3 className="font-heading text-xl font-semibold text-ink">{b.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-soft">{b.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-[#E5E2DE] bg-[#5B2C82] py-16 text-white sm:py-24">
        <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
          <h2 className="font-heading text-3xl font-semibold sm:text-4xl">
            "A helpline in times of need."
          </h2>
          <p className="mt-4 text-white/80">
            It's the spirit we were founded on — and the standard we measure every interaction
            against.
          </p>
        </div>
      </section>
    </PublicLayout>
  );
}
